/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Marketing PRM API
 * API для автоматизированных маркетинговых рассылок и выгрузок (MedMe PRM).

**Разделы продукта:**
- **Рассылки** — отправка сообщений по сегменту (разово или по расписанию)
- **Выгрузки** — таблица пациентов по сегменту (файл, опционально e-mail с архивом)
- **Отчётность** — журнал запусков и доставки

**Авторизация:** HttpOnly cookie `token` (JWT), как в stats-api. Получение токена — через `GET /auth` stats-api.

**Контекст организации:** API работает с понятием «организация» — всем списком бизнесов, к которым у пользователя есть доступ. Сервер резолвит бизнесы автоматически из JWT-токена; `businessId` в query-параметрах не передаётся. Для операций над конкретным бизнесом (создание задачи, принятие условий) `businessId` передаётся в теле запроса.

 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod"

/**
 * @summary Список лидов
 */
export const listLeadsQueryPageDefault = 1

export const listLeadsQueryPageSizeDefault = 25
export const listLeadsQuerySortDefault = `createdAt`
export const listLeadsQueryOrderDefault = `desc`

export const ListLeadsQueryParams = zod.object({
	search: zod.string().optional(),
	status: zod.enum(["new", "in_progress", "processed"]).optional(),
	createdFrom: zod.iso.date().optional(),
	createdTo: zod.iso.date().optional(),
	branchId: zod.string().optional(),
	timezone: zod.string().optional(),
	page: zod.number().min(1).default(listLeadsQueryPageDefault),
	pageSize: zod
		.union([zod.literal(25), zod.literal(50), zod.literal(100)])
		.default(listLeadsQueryPageSizeDefault),
	sort: zod
		.enum(["createdAt", "status", "phone"])
		.default(listLeadsQuerySortDefault),
	order: zod.enum(["asc", "desc"]).default(listLeadsQueryOrderDefault),
})

export const listLeadsResponseDataItemSourceMax = 64

export const listLeadsResponseDataItemCommentMax = 2000

export const ListLeadsResponse = zod.object({
	data: zod.array(
		zod.object({
			id: zod.string(),
			businessId: zod.string(),
			networkId: zod.string().optional(),
			phone: zod.string(),
			phoneNormalized: zod.string(),
			status: zod.enum(["new", "in_progress", "processed"]),
			origin: zod.enum(["widget_exit_intent"]),
			source: zod
				.string()
				.min(1)
				.max(listLeadsResponseDataItemSourceMax)
				.describe(
					"Technical source supplied by Widget; independent from utm.source.",
				),
			utm: zod.object({
				source: zod.string().optional(),
				medium: zod.string().optional(),
				campaign: zod.string().optional(),
				content: zod.string().optional(),
				term: zod.string().optional(),
			}),
			domain: zod.string(),
			pageUrl: zod.url(),
			referrer: zod.string().optional(),
			consentAccepted: zod.boolean(),
			consentAcceptedAt: zod.iso.datetime({}),
			comment: zod.string().max(listLeadsResponseDataItemCommentMax),
			createdAt: zod.iso.datetime({}),
			updatedAt: zod.iso.datetime({}),
		}),
	),
	paging: zod.object({
		page: zod.number(),
		pageSize: zod.number(),
		total: zod.number(),
	}),
})

/**
 * @summary Сводные показатели лидов
 */
export const GetLeadsSummaryQueryParams = zod.object({
	branchId: zod.string().optional(),
})

export const getLeadsSummaryResponseTotalMin = 0

export const getLeadsSummaryResponseNewMin = 0

export const GetLeadsSummaryResponse = zod.object({
	total: zod.number().min(getLeadsSummaryResponseTotalMin),
	new: zod.number().min(getLeadsSummaryResponseNewMin),
})

/**
 * @summary Выгрузить лиды в Excel
 */
export const ExportLeadsQueryParams = zod.object({
	search: zod.string().optional(),
	status: zod.enum(["new", "in_progress", "processed"]).optional(),
	createdFrom: zod.iso.date().optional(),
	createdTo: zod.iso.date().optional(),
	branchId: zod.string().optional(),
	timezone: zod.string().optional(),
})

/**
 * @summary Детали лида
 */
export const GetLeadParams = zod.object({
	leadId: zod.string(),
})

export const getLeadResponseSourceMax = 64

export const getLeadResponseCommentMax = 2000

export const GetLeadResponse = zod.object({
	id: zod.string(),
	businessId: zod.string(),
	networkId: zod.string().optional(),
	phone: zod.string(),
	phoneNormalized: zod.string(),
	status: zod.enum(["new", "in_progress", "processed"]),
	origin: zod.enum(["widget_exit_intent"]),
	source: zod
		.string()
		.min(1)
		.max(getLeadResponseSourceMax)
		.describe(
			"Technical source supplied by Widget; independent from utm.source.",
		),
	utm: zod.object({
		source: zod.string().optional(),
		medium: zod.string().optional(),
		campaign: zod.string().optional(),
		content: zod.string().optional(),
		term: zod.string().optional(),
	}),
	domain: zod.string(),
	pageUrl: zod.url(),
	referrer: zod.string().optional(),
	consentAccepted: zod.boolean(),
	consentAcceptedAt: zod.iso.datetime({}),
	comment: zod.string().max(getLeadResponseCommentMax),
	createdAt: zod.iso.datetime({}),
	updatedAt: zod.iso.datetime({}),
})

/**
 * @summary Изменить статус и комментарий
 */
export const UpdateLeadParams = zod.object({
	leadId: zod.string(),
})

export const updateLeadBodyCommentMax = 2000

export const UpdateLeadBody = zod.object({
	status: zod.enum(["new", "in_progress", "processed"]),
	comment: zod.string().max(updateLeadBodyCommentMax).optional(),
})

export const updateLeadResponseSourceMax = 64

export const updateLeadResponseCommentMax = 2000

export const UpdateLeadResponse = zod.object({
	id: zod.string(),
	businessId: zod.string(),
	networkId: zod.string().optional(),
	phone: zod.string(),
	phoneNormalized: zod.string(),
	status: zod.enum(["new", "in_progress", "processed"]),
	origin: zod.enum(["widget_exit_intent"]),
	source: zod
		.string()
		.min(1)
		.max(updateLeadResponseSourceMax)
		.describe(
			"Technical source supplied by Widget; independent from utm.source.",
		),
	utm: zod.object({
		source: zod.string().optional(),
		medium: zod.string().optional(),
		campaign: zod.string().optional(),
		content: zod.string().optional(),
		term: zod.string().optional(),
	}),
	domain: zod.string(),
	pageUrl: zod.url(),
	referrer: zod.string().optional(),
	consentAccepted: zod.boolean(),
	consentAcceptedAt: zod.iso.datetime({}),
	comment: zod.string().max(updateLeadResponseCommentMax),
	createdAt: zod.iso.datetime({}),
	updatedAt: zod.iso.datetime({}),
})
